
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  label?: string;
  onClick?: () => void;
}

interface DetailPageTemplateProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  backButtonProps?: BackButtonProps;
}

const DetailPageTemplate = ({ 
  title, 
  description, 
  children, 
  backButtonProps 
}: DetailPageTemplateProps) => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    if (backButtonProps?.onClick) {
      backButtonProps.onClick();
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleBackClick}
          className="flex items-center"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          {backButtonProps?.label || "Terug naar dashboard"}
        </Button>
        <div>
          <h1 className="text-2xl font-bold">{title}</h1>
          {description && <p className="text-muted-foreground">{description}</p>}
        </div>
      </div>
      <div className="mt-4">
        {children}
      </div>
    </div>
  );
};

export default DetailPageTemplate;
